export default __webpack_public_path__ + "static/platform-uses-3836992565dc8e8d69c2721f31cd6e59.svg";